"use strict";
/**
 * APITable <https://github.com/apitable/apitable>
 * Copyright (C) 2022 APITable Ltd. <https://apitable.com>
 *
 * This program is free software: you can redistribute it and/or modify
 * it under the terms of the GNU Affero General Public License as published by
 * the Free Software Foundation, either version 3 of the License, or
 * (at your option) any later version.
 *
 * This program is distributed in the hope that it will be useful,
 * but WITHOUT ANY WARRANTY; without even the implied warranty of
 * MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.  See the
 * GNU Affero General Public License for more details.
 *
 * You should have received a copy of the GNU Affero General Public License
 * along with this program.  If not, see <http://www.gnu.org/licenses/>.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.getLinearRowsFormComputed = exports.getVisibleColumnsFormComputed = exports.getPureVisibleRowsFormComputed = exports.getComputedStatus = exports.getComputedInfo = void 0;
const compensator_1 = require("../../../../../../compensator");
const store_1 = require("../../../../../../exports/store");
const base_1 = require("./base");
const calc_1 = require("./calc");
const getComputedInfo = (state, dsId) => {
    const datasheetPack = (0, base_1.getDatasheetPack)(state, dsId);
    return datasheetPack === null || datasheetPack === void 0 ? void 0 : datasheetPack.computedInfo;
};
exports.getComputedInfo = getComputedInfo;
const getComputedStatus = (state, dsId) => {
    const datasheetPack = (0, base_1.getDatasheetPack)(state, dsId);
    return datasheetPack === null || datasheetPack === void 0 ? void 0 : datasheetPack.computedStatus;
};
exports.getComputedStatus = getComputedStatus;
const getPureVisibleRowsFormComputed = (state, dsId) => {
    var _a;
    const datasheetPack = (0, base_1.getDatasheetPack)(state, dsId);
    const pureVisibleRows = (_a = datasheetPack === null || datasheetPack === void 0 ? void 0 : datasheetPack.computedInfo) === null || _a === void 0 ? void 0 : _a.pureVisibleRows;
    if (!pureVisibleRows) {
        return pureVisibleRows;
    }
    if (!compensator_1.compensator.willRemoveRecords.size) {
        return pureVisibleRows;
    }
    return pureVisibleRows.filter((item) => !compensator_1.compensator.checkWillRemoveRecord(item.recordId));
};
exports.getPureVisibleRowsFormComputed = getPureVisibleRowsFormComputed;
const getVisibleColumnsFormComputed = (state, dsId) => {
    var _a;
    const datasheetPack = (0, base_1.getDatasheetPack)(state, dsId);
    return (_a = datasheetPack === null || datasheetPack === void 0 ? void 0 : datasheetPack.computedInfo) === null || _a === void 0 ? void 0 : _a.visibleColumns;
};
exports.getVisibleColumnsFormComputed = getVisibleColumnsFormComputed;
const getLinearRowsFormComputed = (state, dsId) => {
    var _a, _b;
    const datasheetPack = (0, base_1.getDatasheetPack)(state, dsId);
    const linearRows = (_a = datasheetPack === null || datasheetPack === void 0 ? void 0 : datasheetPack.computedInfo) === null || _a === void 0 ? void 0 : _a.linearRows;
    if (!linearRows) {
        return null;
    }
    if (!compensator_1.compensator.willRemoveRecords.size && !compensator_1.compensator.lastGroupInfo) {
        return linearRows;
    }
    const filterConditions = [];
    if (compensator_1.compensator.lastGroupInfo) {
        const _dsId = dsId || state.pageParams.datasheetId;
        if (_dsId) {
            const curGroupInfo = (_b = (0, calc_1.getViewByIdWithDefault)(state, _dsId)) === null || _b === void 0 ? void 0 : _b.groupInfo;
            const maxDepth = curGroupInfo ? curGroupInfo.length : 0;
            filterConditions.push((record) => {
                record.depth = Math.min(record.depth, maxDepth);
                return record.type !== store_1.CellType.GroupTab || record.depth < maxDepth;
            });
        }
    }
    if (compensator_1.compensator.willRemoveRecords.size) {
        filterConditions.push((record) => {
            return !compensator_1.compensator.checkWillRemoveRecord(record.recordId);
        });
    }
    return linearRows.filter((item) => filterConditions.reduce((pass, check) => {
        if (!pass) {
            return pass;
        }
        return check(item);
    }, true));
};
exports.getLinearRowsFormComputed = getLinearRowsFormComputed;
//# sourceMappingURL=computed.js.map